import {ReactNode} from 'react';
import {hoistCmp, XH} from '@xh/hoist/core';
import {SESSION_POINTS} from '../../svc/IntradayService';
import {sparkline} from './MiniCharts';

export interface IntradaySparklineProps {
    /** The ticker whose prices to draw. */
    ticker?: string;
    /** The portfolio whose balance to draw, when there is no ticker. */
    portfolioId?: number;
    className?: string;
    /** Draws the points, or null while they load. Defaults to `sparkline`, spanning the full session. */
    renderer?: (points: number[], slots: number) => ReactNode;
}

/**
 * Today's series of a ticker or a portfolio, from IntradayService. It observes only its own series, so a new bar
 * re-renders this chart and no other, and a series that loads after the grid rendered still shows up.
 */
export const intradaySparkline = hoistCmp.factory<IntradaySparklineProps>({
    model: false,
    render({ticker, portfolioId, className, renderer}) {
        const svc = XH.intradayService,
            points = ticker ? svc.tickerPoints(ticker) : svc.portfolioPoints(portfolioId);

        return renderer ? renderer(points, SESSION_POINTS) : sparkline(points, className, SESSION_POINTS);
    }
});
